module.exports = __webpack_public_path__ + "static/img/icon-communicate.fb6de9e6.svg";